import {setupSchedulerCell} from "../scheduler-cell";

angular
    .module('logbook')
    .directive('shiftSchedulerCell', ['$timeout', function($timeout)
    {
        return {
            restrict: 'E',
			template: require('./shift-scheduler-cell.html'),

            scope: {
                onBind: '=',
                cellObj: '=',
                selectedShift: '=',
                scheduleName: '='
            },

            link: function(scope, elem, attr)
            {
                if (scope.cellObj == undefined)
                {
                    scope.cellObj = { options: {} };
                    console.error('No cellObj passed for scheduler-cell')
                }
                else if (!scope.cellObj.options)
                    scope.cellObj.options = {};

                // Model for values related to the cell
                scope.model = {
                    minutes: {
                        exact: {
                            value: 0
                        },
                        range: {
                            interval: 1,
                            start: 0,
                            end: 1,

                            startEnabled: true,
                            endEnabled: true
                        }
                    },
                    hours: {
                        exact: {
                            value: 0
                        },
                        range: {
                            interval: 1,
                            start: 0,
                            end: 1,

                            startEnabled: true,
                            endEnabled: true
                        },
                        shift: {
                            afterStart: 0,
                            beforeEnd: 0,

                            afterStartEnabled: true,
                            beforeEndEnabled: true
                        }
                    },
                    weekdays: {
                        exact: {
                            Sun: {
                                enabled: true,
                                selected: false
                            },
                            Mon: {
                                enabled: true,
                                selected: false
                            },
                            Tues: {
                                enabled: true,
                                selected: false
                            },
                            Wed: {
                                enabled: true,
                                selected: false
                            },
                            Thurs: {
                                enabled: true,
                                selected: false
                            },
                            Fri: {
                                enabled: true,
                                selected: false
                            },
                            Sat: {
                                enabled: true,
                                selected: false
                            }
                        }
                    },
                    monthdays: {
                        exact: {
                            value: 1
                        },
                        range: {
                            interval: 1,
                            start: 1,
                            end: 1,

                            startEnabled: true,
                            endEnabled: true
                        }
                    }
                };

                scope.elem = elem;
                scope.$timeout = $timeout;
                setupSchedulerCell(scope);

                /**
                 * Sets the shift for the cell and updates related values
                 * @param {{}} shift - The new Shift
                 */
                scope.setSelectedShift = function(shift)
                {
                    scope.selectedShift = shift;
                    if (shift == undefined) return;

                    // Set Available Days according to shift schedule
                    var dayKeys = Object.keys(scope.model.weekdays.exact);

                    for (var localIndex = 0; localIndex < dayKeys.length; localIndex++)
                    {
                        //Logbook Shift Weekday Index for corresponding day object
                        var weekdayIndex = (localIndex + 1 <= 6) ? localIndex + 1 : 0;
                        var day = dayKeys[localIndex];

                        scope.model.weekdays.exact[day].enabled = shift.weekdays.includes(weekdayIndex);
                        if (scope.model.weekdays.exact[day].enabled === false)
                            scope.model.weekdays.exact[day].selected = false;
                    }
                };

                scope.cellObj.type = scope.type;
                scope.cellObj.subType = scope.subType;
                scope.cellObj.addOnChangeEvent = function(func) { scope.onChangeEvents.push(func) };
                scope.cellObj.addOnDeleteEvent = function(func) { scope.onDeleteEvents.push(func) };
                scope.cellObj.setCellType = scope.setCellType;
                scope.cellObj.setSelectedShift = scope.setSelectedShift;

                // On Day button click event
                scope.dayBtnClick = function(e)
                {
                    var day = $(e.currentTarget).attr('weekday');

                    if (day != undefined)
                        scope.model.weekdays.exact[day].selected = !scope.model.weekdays.exact[day].selected;

                    scope.onChange(e);
                };

                scope.setCellType(scope.type, scope.subType);

                if (typeof scope.onBind === 'function')
                    scope.onBind(scope.cellObj);

                scope.setCellType(scope.type, scope.subType, null, !scope.cellObj.options.suppressOnChange);

                if (scope.selectedShift)
                    scope.setSelectedShift(scope.selectedShift);
            }
        }
    }]);